<template>
    <div class="exhibition" v-if="wid == '' || wid == undefined">
        <ul class="layout-content categoryevery clearfix">
            <li v-for="(category, index) in categories" :key="index" >
              <el-select popper-class="popperclass" class="cselect" v-model="category.value" placeholder="请选择" @change="handleSelectChange(category.type)">
                <el-option
                  class="celoption"
                  v-for="item in category.enums"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </li>
        </ul>
        <div class="layout-content">
            <ul class="categorywork clearfix">
                <li v-for="(item, index) in works" :key="index" :class="{'noright':index%4==3}">
                    <img @click="goDetail(item.id)" :src="url +'/assets/upload/'+ item.cover" alt="未上传封面">
                    <el-tooltip v-if="item.top16 != '1000'" class="item" effect="dark" content="16强作品" placement="top-start">
                       <div class="status" :style="{background: 'url(' + url + '/assets/img/top16.png)'}">
                       </div>
                    </el-tooltip>
                    <div class="titlebox">
                       <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                           <span class="title">{{item.name}}</span>
                       </el-tooltip>
                    </div>
                    <div class="categorycon">
                        <span class="categoryname">{{groups[item.gid].name}}</span>
                        <div>
                            <span class="categoryname">编号：{{item.userid}}</span>
                            <span class="wrapline">|</span>
                            <span class="area">作者：{{item.username}}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <el-pagination
               style="float:right;margin-top:20px;margin-bottom:20px;"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
               :current-page="parseInt(page)"
               :page-sizes="[20, 30, 50]"
               :page-size="parseInt(rows)"
               layout="total, sizes, prev, pager, next, jumper"
               :total="parseInt(total)"
               class="table-page">
            </el-pagination>
        </div>
    </div>
    <div class="exhibition-detail" v-else>
        <div class="titlebox">
            <span class="title">{{curWork.name}}</span>
        </div>
        <div class="detail-con layout-content" >
            <div class="leftbox" ref="leftbox">
              <div class="leftbox-con" :class="topShow == true ? 'top' : ''">
                <div class="label">分组：</div>
                <div class="value">{{groups[curWork.gid].name}}</div>
                <div class="label">作者姓名：</div>
                <div class="value">{{curWork.username}}</div>
                <div class="label">学校：</div>
                <div class="value">{{curWork.school}}</div>
                <div class="label">专业：</div>
                <div class="value">{{curWork.major}}</div>
                <div class="label">指导老师：</div>
                <div class="value">{{curWork.teacher}}</div>
                <div class="label">编号：</div>
                <div class="value">{{curWork.userid}}</div>
              </div>
            </div>
            <div class="rightbox" ref="rightbox"
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
            >
              <div class="box-info" >作品说明：</div>
              <div class="box-info" style="min-height: 50px">
                <div class="box-info" style="white-space: pre-line;" v-if="curWork.note.length > 10">
                  {{curWork.note}}
                </div>
              </div>

                <div class="box-info">作品图纸：</div>
                <div class="box-info">
                    <el-image max-width="600px" v-for="(imgUrl, index) in curWork.imgs_url.split(':')[0].split(';')" :key="index" :src="url +'/assets/upload/'+ imgUrl" alt="图片加载失败"
                    :preview-src-list="imgsList"
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
                    ></el-image>
                </div>

                <div class="box-info" v-if="curWork.imgs_url.split(':').length > 1">实体模型照片：</div>
                <div class="box-info" v-if="curWork.imgs_url.split(':').length > 1">
                    <el-image max-width="600px" v-for="(imgUrl, index) in curWork.imgs_url.split(':')[1].split(';')" :key="index" :src="url +'/assets/upload/'+ imgUrl" alt="图片加载失败"
                    :preview-src-list="imgsList"
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
                    ></el-image>
                </div>

               <div class="box-info" v-if="curWork.video != ''">作品视频：</div>
               <div class="box-info" v-if="curWork.video != ''">
                    <video ref="video1" width="600px" height="375px" controls
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
                    >
                        <source :src="url +'/assets/upload/'+ curWork.video" type="video/mp4">
                        当前浏览器不支持该视频格式
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Loading } from 'element-ui'

export default {
  data () {
    return {
      url: this.API,
      categories: [{
        type: 'year',
        value: '2021',
        enums: [{
          id: 1,
          name: '2021'
        }],
      }, {
        type: 'group',
        value: '0',
        enums: [
          {'id': '0', 'name': '全部作品'},
          {'id': '1', 'name': '大一作品'},
          {'id': '2', 'name': '大二作品'},
          {'id': '3', 'name': '大三作品'},
        ],
      }],
      groups: [
        {'id': '0', 'name': '全部作品'},
        {'id': '1', 'name': '大一作品'},
        {'id': '2', 'name': '大二作品'},
        {'id': '3', 'name': '大三作品'},
      ],
      topShow: false,
      page: '1',
      rows: '20',
      wid: '',
      works: [],
      imgsList: [],
      curWork: {},
      total:'104'
    }
  },
  watch: {
    '$route'(to, from){
      this.wid = this.$route.params.id ? this.$route.params.id : ''
      this._getData()
    }
  },
  computed: {
    pid() {
      return this.categories[1].value
    }
  },
  created () {
    console.log('created', this.wid)
  },
  mounted () {
    this.wid = this.$route.params.id ? this.$route.params.id : ''
    this._getData()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  filters: {
  },
  methods: {
    handleSelectChange(type){
      this.page = 1
      this._getData()
    },
    handleScroll(){
      if (this.wid != "" && this.wid != undefined) {
        const sTop = document.documentElement.scrollTop
        const top = this.$refs.leftbox.offsetTop
        const height = this.$refs.rightbox.offsetHeight
        if (sTop > top && sTop < height) {
          this.topShow = true
        }else{
          this.topShow = false
        }
      }
    },
    _getData: function () {
      let _t = this
      let ld = Loading.service({'fullscreen': true, 'text': '数据加载中，请稍后'})
      if (_t.wid == '' || _t.wid == undefined) {
        axios.post(_t.API + '/api/work/toplist/', {gid: _t.pid, page: _t.page, rows: _t.rows, total: _t.total})
          .then(function (resp) {
            _t.works = resp.data.data
            ld.close()
          })
          .catch(function (error) {
            console.log(error)
            ld.close()
          })
        this.total= _t.total
      } else {
        axios.post(_t.API + '/api/work/topdetail/', {id: _t.wid})
          .then(function (resp) {
            ld.close()
            if(resp.data.data == undefined) {
              _t.$messagewarning('当前作品不存在')
              // _t.$router.push('/exhibition')
            } else {
              _t.curWork = resp.data.data
              var result = []
              for(var i=0; i<_t.curWork.imgs_url.split(':')[0].split(';').length; i++) {
                var tmpImg = _t.curWork.imgs_url.split(':')[0].split(';')[i]
                if (tmpImg != '' && tmpImg != undefined) result.push(_t.url +'/assets/upload/'+ tmpImg)
              }
              if (_t.curWork.imgs_url.split(':').length > 1) {
                for(var i=0; i<_t.curWork.imgs_url.split(':')[1].split(';').length; i++) {
                  var tmpImg = _t.curWork.imgs_url.split(':')[1].split(';')[i]
                  if (tmpImg != '' && tmpImg != undefined) result.push(_t.url +'/assets/upload/'+ tmpImg)
                }
              }
              _t.imgsList = result
            }
          })
          .catch(function (error) {
            ld.close()
            console.log(error)
          })
      }
    },
    handleSizeChange (val) {
      this.rows = val
      this.page = 1 // size change, 回到第一页
      this._getData()
    },
    handleCurrentChange (val) {
      this.page = val
      this._getData()
    },
    goDetail (val) {
      console.log('work wid:', val)
      let routeUrl = this.$router.resolve({
        path: `/exhibition/${val}`
      })
      window.open(routeUrl .href, '_blank')
    }
  }
}
</script>

<style scoped>
.exhibition{
  font-family: PingFangSC-Regular;
}
.banner{
  width: 1440px;
  padding-left: (100% - 1440px) / 2;
  padding-right: (100% - 1440px) / 2;
}
.layout-content{
  width: 1008px;
  padding-left: (100% - 1008px) / 2;
  padding-right: (100% - 1008px) / 2;
  margin:0 auto;
  font-size:18px;
}
.cselect{
  width: 180px;
}

.label {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #34495E;
  letter-spacing: 0;
  text-align: left;
  width: 100px;
}
.data {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #34495E;
  letter-spacing: 0;
  text-align: left;
  width: 100%;
}
.data-img {
  max-width: 400px;
  max-height: 300px;
}
.current{
    background:#F7B52D;
}
.noright{
    margin-right: 0px !important;
}
.clearfix:after{
  content:"";
  display: table;
  clear:both;
}
.clearfix{
  *zoom: 1;
}
@font-face {
  font-family: sy;
  src: url("../assets/font/SourceHanSansK-Regular.ttf");
}
@font-face {
  font-family: sybold;
  src: url("../assets/font/SourceHanSansK-Bold.ttf");
}
@font-face {
  font-family: sylight;
  src: url("../assets/font/SourceHanSansK-Light.ttf");
}
.status{
    position: absolute;
    top:0;
    right:0;
    width: 50px;
    height: 50px;
}
.status a, .status span{
    display: none;
    text-decoration: none;
}
.status:hover {
    cursor: pointer;
}
.status:hover a.statusnote{
    cursor:pointer;
    position:absolute;
    top:0; width:100%;
    height:100%;
    z-index:100;
    left:0;
    display:block;
}
.status:hover span{
    cursor:pointer;
    position:absolute;
    bottom:0;
    width:200px;
    height:100%;
    z-index:10;
    left:0;
    display:block;
    filter:alpha(opacity=100);
    -moz-opacity: 1;
    opacity: 1;
}
.mywork{
    height:60px;
    background: black;
    color: white;
    font-family: sybold;
    font-size: 30px;
    text-align: center;
    line-height: 60px;
    margin-bottom: 40px;
    border-radius:4px;
    margin-top:40px;
}
.allwork{
    text-align: center;
    font-family: sylight;
    font-size: 17px;
    color:black;
}
.categoryevery{
    margin-top:10px !important;
    margin: 0 auto;
    text-align: center;
}
.categoryevery li{
    float: left;
    min-width: 135px;
    height: 40px;
    border-radius: 2px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: black;
    margin-left: 10px;
    border-radius: 2px;
}
.categoryevery li:nth-child(1){
    margin-left: 0px;
}
.categoryevery .active{
    background: #F7B52D;
    color: white;
}
.categorywork{
    margin: 0 auto;
    margin-top: 40px;
    min-height: 500px;
}
.categorywork li{
    position: relative;
    float: left;
    width: 232px;
    margin-right: 26px;
    height: 320px;
    margin-bottom: 20px;
}
.categorywork img{
    display: block;
    width:100%;
    height: 232px;
    background: #f2f6fa;
    text-align: center;
}
.status:hover a.statusnote{
    cursor:pointer;
    position:absolute;
    top:0; width:100%;
    height:100%;
    z-index:100;
    left:0;
    display:block;
}
.status:hover span{
    cursor:pointer;
    position:absolute;
    bottom:0;
    width:200px;
    height:100%;
    z-index:10;
    left:0;
    display:block;
    filter:alpha(opacity=100);
    -moz-opacity: 1;
    opacity: 1;
}
.titlebox{
}
.title{
    display: block;
    margin: 5px 0;
    font-family: sybold;
    font-size: 17px;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.notification {
    text-align: center;
    margin-top: 100px;
}
.categorycon{
    font-family: sy;
    font-size: 13px;
}
.detail-con {
    display: flex;
}
.exhibition-detail .titlebox {
    height: 100px;
    background: #f2f6fa;
    display: flex;
}
.exhibition-detail .title {
    font-size: 30px;
    font-family: sybold;
    line-height: 45px;
    position: relative;
    margin-left: calc((100% - 1008px) / 2);
    margin-right: calc((100% - 1008px) / 2);
    white-space: pre-wrap;
    word-break: break-word;
    display: flex;
    vertical-align: middle;
    align-items: center;
}
.leftbox {
    width: 185px;
    margin: 40px 38px 0 0;
    font-family: sy;
    font-size: 17px;
}
.leftbox-con {
    border-right: 3px solid #999;
}
.rightbox {
    margin-top: 20px;
    width: 600px;
    font-family: sy;
    font-size: 15px;
}
.rightbox img{
    margin-bottom: 10px;
}
.label{
    color: #999;
    margin-bottom: 5px;
}
.value{
    margin-bottom: 20px;
    white-space: pre-wrap;
}
img {
    border-radius: 2px;
}
.top{
  z-index: 1000;
  position: fixed !important;
  top: 0;
  width: 185px;
  margin: 20px 38px 0 0;
  font-family: sy;
  font-size: 17px;
}
</style>
<style>
.cselect .el-input__inner{
  border: 1px solid black;
  background-color: #fff;
  font-size: 16px;
}
.cselect .el-icon-arrow-up{
  font-size: 18px !important;
}
.el-image {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// Exhibition.vue?43ed547b